import { useState, useCallback } from 'react';
import { servicesAPI } from '@/services/api';
import { MSAService } from '@/types';
import { getErrorMessage } from '@/utils/errorUtils';
import { HealthStatus } from '@/types/health';

export const useCustomerUserSearch = (
  setSubscribedServiceIds: React.Dispatch<React.SetStateAction<Set<number>>>,
  _setHealthStatuses: React.Dispatch<React.SetStateAction<Record<number, HealthStatus>>>,
  setError: (message: string) => void
) => {
  const [searchResults, setSearchResults] = useState<MSAService[]>([]);
  const [searchLoading, setSearchLoading] = useState(false);

  const handleSearch = useCallback(async (query: string, category: string) => {
    try {
      setSearchLoading(true);
      const results = await servicesAPI.searchPublicServices(
        query || undefined,
        category || undefined
      );
      setSearchResults(results || []);
      
      const userServices = await servicesAPI.getUserServices();
      const subscribedIds = new Set<number>((userServices || []).map((s: MSAService) => s.id));
      setSubscribedServiceIds(subscribedIds);
    } catch (error: unknown) {
      console.error('Failed to search services:', error);
      setError(getErrorMessage(error, '서비스 검색에 실패했습니다.'));
    } finally {
      setSearchLoading(false);
    }
  }, [setSubscribedServiceIds, setError]);

  return {
    searchResults,
    searchLoading,
    handleSearch,
  };
};

